import { useEffect, useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const API_URL = process.env.REACT_APP_API_BASE_URL + "/api/galleries/create"

const CreateGallery = () => {
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [categoryId, setCategoryId] = useState("");
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    axios.get(process.env.REACT_APP_API_BASE_URL + "/api/categories", {
      headers: { Authorization: `Bearer ${token}` },
    }).then((response) => setCategories(response.data.categories || []))
      .catch(() => setMessage("Error loading categories"));
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();
    const token = localStorage.getItem("token");

    setLoading(true);
    setMessage("");

    try {
      const res = await axios.post(
        API_URL,
        { title, description, category_id: categoryId || null },
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Gallery Created Successfully:", res.data);
      setMessage("Gallery Created!");
      setTimeout(() => navigate("/dashboard"), 2000);
    } catch (error) {
      console.error(
        "Gallery Creation Error:",
        error.response?.data || error.message
      );
      setMessage("Error creating gallery");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex items-center justify-center min-h-screen bg-gray-100">
      <div className="bg-white p-8 shadow-lg rounded-lg w-full max-w-md">
        <h2 className="text-3xl font-bold text-center mb-6">Create Gallery</h2>

        {message && (
          <p
            className={`text-center p-2 rounded-md my-6 ${
              message.includes("Error")
                ? "bg-red-500 text-white"
                : "bg-green-500 text-white"
            }`}
          >
            {message}
          </p>
        )}

        <form onSubmit={handleSubmit} className="space-y-4">
          <div>
            <label className="block text-gray-700 font-medium">
              Photography category
            </label>
            <select
              value={categoryId}
              onChange={(e) => setCategoryId(e.target.value)}
              className="w-full p-3 border rounded-lg focus:outline-none"
            >
              <option value="">Uncategorized (dashboard only)</option>
              {categories.map((category) => (
                <option key={category.id} value={category.id}>{category.name}</option>
              ))}
            </select>
          </div>

          <div>
            <label className="block text-gray-700 font-medium">Title</label>
            <input
              type="text"
              maxLength={40}
              placeholder="Enter gallery title"
              value={title}
              onChange={(e) => setTitle(e.target.value)}
              className="w-full p-3 border rounded-lg focus:outline-none"
              required
            />
          </div>

          <div>
            <label className="block text-gray-700 font-medium">
              Description
            </label>
            <textarea
              maxLength={256}
              placeholder="Enter gallery description"
              value={description}
              onChange={(e) => setDescription(e.target.value)}
              className="w-full p-3 border rounded-lg focus:outline-none resize-none"
              rows="3"
            ></textarea>
          </div>

          <button
            type="submit"
            className="w-full bg-blue-500 text-white py-3 rounded-lg font-semibold hover:bg-blue-600 transition duration-200 disabled:opacity-50"
            disabled={loading}
          >
            {loading ? "Creating..." : "Create Gallery"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default CreateGallery;
